__turbopack_context__.v({
  "intro": "Intro-module-scss-module__3-F9nW__intro",
  "main": "Intro-module-scss-module__3-F9nW__main",
});
